import { IDailyProgress, ILearningTopicsGetListQuery, IWeeklyProgress, LearningJourneyData, TodaySuggestion } from '@/features/student/StudentProgress/types';
import api from './api';
import queryString from 'query-string';
import { LEVEL } from '@/features/landing/constants';
import { IPagination } from '@/common/interface';

export interface ISubtopic {
    id: string;
    difficulty: string;
    focus: string[];
    grammar_points: string[];
    subtopic_description: string;
    subtopic_id: string;
    subtopic_name: string;
    vocab_points: string[];
    xp: number;
    progress: number;
}
export interface ITopic {
    id: string;
    grammar_points: string[];
    topic_description: string;
    topic_id: string;
    topic_name: string;
    subtopics: {
        pagination: IPagination;
        results: ISubtopic[];
    };
}
export interface LearningTopic {
    cerfs: LEVEL[];
    count: number;
    results: {
        id: string;
        adjustment_strategy: string;
        cefr_level: LEVEL;
        is_active: string;
        learning_goal: string;
        topics: {
            pagination: IPagination;
            results: ITopic[];
        };
    }[];
}

export interface StatsData {
    wordsLearned: number;
    currentStreak: number;
    accuracyRate: number;
    timeStudied: number;
}

class StudentProgressService {
    async getLearningJourney(): Promise<LearningJourneyData> {
        const response = await api.get('/progress/student-progress/learning-journey-v2/');
        return response.data;
    }

    async getLearningTopics(query: ILearningTopicsGetListQuery): Promise<LearningTopic> {
        const queryStr = queryString.stringify(query);
        const response = await api.get('/progress/user-learning-paths/?' + queryStr);
        return response.data;
    }

    async getTodaySuggestions(): Promise<TodaySuggestion[]> {
        const response = await api.get('/progress/student-progress/today-suggestions/');
        return response.data;
    }

    async getStats(): Promise<StatsData> {
        const response = await api.get('/progress/student-progress/stats/');
        return response.data;
    }

    async getDailyProgress(): Promise<IDailyProgress[]> {
        const response = await api.get('/progress/user-daily-progress/');
        return response.data;
    }

    async getWeeklyProgress(): Promise<IWeeklyProgress[]> {
        const response = await api.get('/progress/weekly-progress/');
        return response.data;
    }
}

export default new StudentProgressService();
